<template>
  <div class="mb-4">
    <v-select
      v-model="selected"
      :items="availableAutonomies"
      item-text="label"
      item-value="id"
      :label="label"
    />

    <p v-show="selected" class="mt-4" ref="title">
      <b>Restante equipa:</b>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    automyComponents: { type: Array, default: () => [] }
  },
  data() {
    return {}
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(autonomy) {
        this.$emit('input', autonomy)
      }
    },
    availableAutonomies() {
      return this.automyComponents.map(a => ({
        label: a.label,
        id: a.id
      }))
    }
  },
  methods: {}
}
</script>
